import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function queryList(data){
  return request({
    url:applicationName+'/web/brandInformation/list',
    method:'get',
    params:data
  })
}

export function queryHtml(data){
  return request({
    url:applicationName+'/web/brandInformation/html',
    method:'get',
    params:data
  })
}

export function queryBackImg(data){
  return request({
    url:applicationName+'/web/brandInformation/backImg',
    method:'get',
    params:data
  })
}